import { isPending } from "App/apiMiddleware";
import get from "lodash/get";
import startsWith from "lodash/startsWith";
import { createSelector } from "reselect";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const getConnectionsDataMap = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].listConnections`), (data) => data);
export const getConnectionsDictionaryMap = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].typesConnection`), (data) => data);
export const getSettingsDataMap = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].listSettings`), (data) => data);
export const getSettingsDictionaryMap = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].typesSetting`), (data) => data);
export const getExpandedPermissions = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].expandedPermissions`, []), (expandedPermissions) => expandedPermissions);
export const getReloadOntologyInProgress = (state) => isPending(state, actionTypes.RELOAD_ONTOLOGY);
export const getInProgress = (state) => isPending(state, actionTypes.GET_SETTINGS) ||
    isPending(state, actionTypes.GET_SETTINGS_TYPE_DICTIONARY) ||
    isPending(state, e => startsWith(e, `${actionTypes.SAVE_SETTING}_`)) ||
    isPending(state, e => startsWith(e, `${actionTypes.SAVE_CONNECTION}_`)) ||
    getReloadOntologyInProgress(state);
